import React from 'react'
import TestimonialCard from './TestimonialCard'

const TestimonialsSection: React.FC = () => {
  const testimonialsRow1 = [
    {
      id: 1,
      text: 'BritFiler is the easiest platform I\'ve used for Self Assessment. The guided steps were clear, and I received my HMRC confirmation within minutes.',
      userName: 'Stephen A.',
      userTitle: 'Director, Thricecube Empire Ltd',
      rating: 5,
    },
    {
      id: 2,
      text: 'Corporation Tax used to take hours. With BritFiler, I filed in under 20 minutes, and the validation checks gave me full confidence before submission.',
      userName: 'Toluwani A.',
      userTitle: 'Director, Twanny Luxe Limited',
      rating: 5,
    },
    {
      id: 3,
      text: 'I used to dread the paperwork. BritFiler made filing my CT600 and company accounts simple and stress-free.',
      userName: 'Dr. Damola A.',
      userTitle: 'Director, Africa Piano Lessons Limited',
      rating: 5,
    },
    {
      id: 4,
      text: 'The support team replied within an hour and answered all my questions clearly. Very professional and helpful.',
      userName: 'Abimbola A.',
      userTitle: 'Director, Cedar Haven Properties Limited',
      rating: 5,
    },
    {
      id: 5,
      text: 'The reminder feature kept me ahead of deadlines. Filing was quick, simple, and secure.',
      userName: 'Ben A.',
      userTitle: 'Sole trader, Birmingham',
      rating: 5,
    },
  ]

  const testimonialsRow2 = [
    {
      id: 6,
      text: 'Self Assessment, Corporation Tax, and Confirmation Statements — all handled together without switching platforms.',
      userName: 'Sam O.',
      userTitle: 'Director, Urban Clean Ltd',
      rating: 5,
    },
    {
      id: 7,
      text: 'Affordable pricing with everything I needed. Upgrading for accountant review was easy when required.',
      userName: 'SMLasisi',
      userTitle: 'Director, SMLasisi UK Limited',
      rating: 5,
    },
    {
      id: 8,
      text: 'The step-by-step wizard made it so easy — even for someone with no accounting background. The whole process felt modern and stress-free.',
      userName: 'Grace O.',
      userTitle: 'eCommerce Seller, Coventry',
      rating: 5,
    },
    {
      id: 9,
      text: 'The reminder system ensured I didn\'t miss my deadline. Filing was fast and hassle-free.',
      userName: 'DJ Whales.',
      userTitle: 'Director, DeeJay Whales Limited',
      rating: 5,
    },
    {
      id: 10,
      text: 'BritFiler combines compliance, speed, and accuracy. Managing company filings is now much easier.',
      userName: 'Tino A.',
      userTitle: 'Business owner, Birmingham',
      rating: 5,
    },
  ]

  return (
    <section className='py-20 bg-white px-4 sm:px-6 lg:px-20'>
      <div className='w-full mx-auto'>
        {/* Header */}
        <div className='text-center mb-16'>
          <h2 className='text-4xl font-bold text-gray-900 mb-4'>
            What Our Users Say
          </h2>
          <p className='text-lg text-gray-600 max-w-2xl mx-auto'>
            Find out how our platform has changed the tax filing services
            experience for diverse users.
          </p>
        </div>

        {/* Mobile: user-controlled swipe carousel (scroll-snap, no auto-advance).
            Each card snaps to a readable width instead of the desktop marquee,
            which is clipped and unreadable on small screens. */}
        <div className='md:hidden'>
          <div className='flex gap-4 overflow-x-auto snap-x snap-mandatory scroll-px-4 sm:scroll-px-6 px-4 sm:px-6 -mx-4 sm:-mx-6 pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
            {[...testimonialsRow1, ...testimonialsRow2].map(testimonial => (
              <TestimonialCard
                key={`m-${testimonial.id}`}
                className='snap-start'
                text={testimonial.text}
                userName={testimonial.userName}
                userTitle={testimonial.userTitle}
                rating={testimonial.rating}
              />
            ))}
          </div>
          <p className='mt-1 text-center text-xs text-gray-400'>Swipe to see more →</p>
        </div>

        {/* Desktop: auto-scrolling marquee rows */}
        <div className='hidden md:block space-y-6'>
          {/* Row 1 - Scrolling Left */}
          <div className='relative overflow-hidden'>
            <div className='flex space-x-6 animate-scroll-left'>
              {[...testimonialsRow1, ...testimonialsRow1].map(
                (testimonial, index) => (
                  <TestimonialCard
                    key={`${testimonial.id}-${index}`}
                    text={testimonial.text}
                    userName={testimonial.userName}
                    userTitle={testimonial.userTitle}
                    rating={testimonial.rating}
                  />
                )
              )}
            </div>
            {/* Fade effects */}
            <div className='absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-gray-50 to-transparent pointer-events-none z-10'></div>
            <div className='absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-gray-50 to-transparent pointer-events-none z-10'></div>
          </div>

          {/* Row 2 - Scrolling Right */}
          <div className='relative overflow-hidden'>
            <div className='flex space-x-6 animate-scroll-right'>
              {[...testimonialsRow2, ...testimonialsRow2].map(
                (testimonial, index) => (
                  <TestimonialCard
                    key={`${testimonial.id}-${index}`}
                    text={testimonial.text}
                    userName={testimonial.userName}
                    userTitle={testimonial.userTitle}
                    rating={testimonial.rating}
                  />
                )
              )}
            </div>
            {/* Fade effects */}
            <div className='absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-gray-50 to-transparent pointer-events-none z-10'></div>
            <div className='absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-gray-50 to-transparent pointer-events-none z-10'></div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TestimonialsSection
